<template>
  <scoped>
    <template v-if="extension && extension.toLowerCase() == 'pdf'">
      <object :data="source" />
    </template>
    <template v-else>
      <a
        :download="`${title}.${extension}`"
        :href="source"
      >
        <Button title="Download" />
      </a>
    </template>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import {onBeforeMount, ref} from "vue"
  import {File as FileClient} from "@/endpoints/rutsolve/rest/file"

  const props = defineProps({
    data: {
      default: null,
      required: false,
      type: String
    },
    extension: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    },
    url: {
      default: null,
      required: false,
      type: String
    }
  })

  const source = ref<string>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    if (props.url) {
      source.value = await FileClient.read(props.url)
    } else {
      source.value = `data:application/${props.extension};base64,${props.data}`
    }
  }
</script>
